/**
 * md5 算法模块
 * @param {*} str 传入内容
 * 返回 小写密文
 */
const md5 = (str) => {
  // 方法返回指定索引处的char值
  const hexChr = '0123456789abcdef';
  let x = str2blksMD5(str);
  let a = 1732584193;
  let b = -271733879;
  let c = -1732584194;
  let d = 271733878;
  for (let i = 0; i < x.length; i += 16) {
    let olda = a;
    let oldb = b;
    let oldc = c;
    let oldd = d;
    a = ff(a, b, c, d, x[i + 0], 7, -680876936);
    d = ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = ff(c, d, a, b, x[i + 10], 17, -42063);
    b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = gg(b, c, d, a, x[i + 0], 20, -373897302);
    a = gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = hh(a, b, c, d, x[i + 5], 4, -378558);
    d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = hh(d, a, b, c, x[i + 0], 11, -358537222);
    c = hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = ii(a, b, c, d, x[i + 0], 6, -198630844);
    d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = add(a, olda);
    b = add(b, oldb);
    c = add(c, oldc);
    d = add(d, oldd);
  }

  function rhex(num) {
    str = '';
    for (let j = 0; j <= 3; j++) {
      str +=
        hexChr.charAt((num >> (j * 8 + 4)) & 0x0f) +
        hexChr.charAt((num >> (j * 8)) & 0x0f);
    }
    return str;
  }

  function str2blksMD5(str) {
    let nblk = ((str.length + 8) >> 6) + 1;
    let blks = new Array(nblk * 16);
    for (var i = 0; i < nblk * 16; i++) blks[i] = 0;
    // eslint-disable-next-line no-redeclare
    for (var i = 0; i < str.length; i++) {
      blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
    }
    blks[i >> 2] |= 0x80 << ((i % 4) * 8);
    blks[nblk * 16 - 2] = str.length * 8;
    return blks;
  }

  function add(x, y) {
    let lsw = (x & 0xffff) + (y & 0xffff);
    let msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xffff);
  }

  function rol(num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt));
  }

  function cmn(q, a, b, x, s, t) {
    return add(rol(add(add(a, q), add(x, t)), s), b);
  }

  function ff(a, b, c, d, x, s, t) {
    return cmn((b & c) | (~b & d), a, b, x, s, t);
  }

  function gg(a, b, c, d, x, s, t) {
    return cmn((b & d) | (c & ~d), a, b, x, s, t);
  }

  function hh(a, b, c, d, x, s, t) {
    return cmn(b ^ c ^ d, a, b, x, s, t);
  }

  function ii(a, b, c, d, x, s, t) {
    return cmn(c ^ (b | ~d), a, b, x, s, t);
  }
  return rhex(a) + rhex(b) + rhex(c) + rhex(d);
};

/**
 * html 转ubb
 * @param {*} str
 */
const ubbEncode = (str) => {
  if (!str || str == null) return '';
  str = str.replace(/"/gi, '&quot;');
  str = str.replace(/</gi, '&lt;');
  str = str.replace(/>/gi, '&gt;');
  str = str.replace(/\n/gi, '');
  // str = str.replace(/\[code\](.+?)\[\/code\]/ig, function ($id1, $id2) {
  //   return phpcode($id2);
  // });
  str = str.replace(/\[hr\]/gi, '<hr />');
  str = str.replace(/\[\/(size|color|font|backcolor)\]/gi, '</font>');
  str = str.replace(/\[(sub|sup|u|i|strike|b|blockquote|li)\]/gi, '<$.id1>');
  str = str.replace(/\[\/(sub|sup|u|i|strike|b|blockquote|li)\]/gi, '</$.id1>');
  str = str.replace(/\[\/align\]/gi, '</p>');
  str = str.replace(/\[(\/)?h([1-6])\]/gi, '<$.id1h$.id2>');
  str = str.replace(
    /\[align=(left|center|right|justify)\]/gi,
    '<p align="$.id1">'
  );
  str = str.replace(/\[size=(\d+?)\]/gi, '<font size="$.id1">');
  str = str.replace(/\[color=([^\[\<]+?)\]/gi, '<font color="$.id1">');
  str = str.replace(
    /\[backcolor=([^\[\<]+?)\]/gi,
    '<font style="background-color:$.id1">'
  );
  str = str.replace(/\[font=([^\[\<]+?)\]/gi, '<font face="$.id1">');
  str = str.replace(
    /\[list=(a|A|1)\](.+?)\[\/list\]/gi,
    '<ol type="$.id1">$.id2</ol>'
  );
  str = str.replace(/\[(\/)?list\]/gi, '<$.id1ul>');
  // str = str.replace(/\[s:(\d+)\]/ig, function ($id1, $id2) {
  //   return smilepath($id2);
  // });
  str = str.replace(
    /\[img\]([^\[]*)\[\/img\]/gi,
    '<img src="$.id1" border="0" />'
  );
  str = str.replace(
    /\[url=([^\]]+)\]([^\[]+)\[\/url\]/gi,
    '<a href="$.id1">' + '$.id2' + '</a>'
  );
  str = str.replace(
    /\[url\]([^\[]+)\[\/url\]/gi,
    '<a href="$.id1">' + '$.id1' + '</a>'
  );
  return str;
};

/**
 * ubb转html
 * @param {*} str
 */
const ubbDecode = (str) => {
  if (!str || str == null) return '';
  str = str.replace(/<br[^>]*>/gi, '\n');
  str = str.replace(/<p[^>\/]*\/>/gi, '\n');
  str = str.replace(/\son[\w]{3,16}\s?=\s*([\'\"]).+?\1/gi, '');
  str = str.replace(/<hr[^>]*>/gi, '[hr]');
  str = str.replace(/<(sub|sup|u|strike|b|i|pre)>/gi, '[$.id1]');
  str = str.replace(/<\/(sub|sup|u|strike|b|i|pre)>/gi, '[/$.id1]');
  str = str.replace(/<(\/)?strong>/gi, '[$.id1b]');
  str = str.replace(/<(\/)?em>/gi, '[$.id1i]');
  str = str.replace(/<(\/)?blockquote([^>]*)>/gi, '[$.id1blockquote]');
  // str = str.replace(/<img[^>]*smile=\"(\d+)\"[^>]*>/gi, '[s:$.id1]')
  // str = str.replace(
  //   /<img[^>]*src=[\'\"\s]*([^\s\'\"]+)[^>]*>/gi,
  //   '[img]' + '$.id1' + '[/img]'
  // )
  // str = str.replace(
  //   /<a[^>]*href=[\'\"\s]*([^\s\'\"]*)[^>]*>(.+?)<\/a>/gi,
  //   '[url=$.id1]' + '$.id2' + '[/url]'
  // )
  // str = str.replace(/<[^>]*?>/gi, '')
  str = str.replace(/&amp;/gi, '&');
  str = str.replace(/&lt;/gi, '<');
  str = str.replace(/&gt;/gi, '>');
  str = str.replace(/&quot;/gi, '"');
  return str;
};

/**
 * 图片压缩组件 canvas
 * @param {*} options 传入参数
 * {file:'需要压缩的图片',callback:'压缩后回调(options)'
 * ,type:'空默认文件类型',name:'空默认文件名'
 * ,maxsize:'图片限制大小'
 * ,max:'图片尺寸缩放比例默认1'
 * ,scale:'图片清晰度压缩比例，默认1'
 * ,marktext:'加水印文字'
 * ,markstyle:'水印文字样式||rgba( 255 , 255 , 255 , 0.5 )'
 * ,markfont:'水印文字大小||bold 1rem Arial'
 * ,markx:'左边距|| 10',
 * ,marky:'顶边距|| 20'
 * }
 * 返回{base64,size,width,height}
 */
const imgMin = (options) => {
  // 待处理图片文件
  let file = options.file;
  if (file == null) {
    return options.callback();
  }

  // 初始化对象，没填某项时使用默认值代替
  options = {
    // 对象读取new FileReader()
    reader: options.reader || null,
    // 文件类型
    type: options.type || file.type,
    // 指定文件名称||原文件名
    name: options.name || file.name,
    // 图片限制大小
    maxsize: options.maxsize || 0,
    // 图片尺寸缩放比例，默认1
    max: options.max || 1,
    // 图片清晰度压缩比例，默认1
    scale: options.scale || 1,
    // 加水印文字
    marktext: options.marktext || null,
    // 水印文字样式
    markstyle: options.markstyle || 'rgba( 255 , 255 , 255 , 0.5 )',
    // 水印文字大小
    markfont: options.markfont || 'bold 1rem Arial',
    // 左边距
    markx: options.markx || 10,
    // 顶边距
    marky: options.marky || 20,
    // 处理完回调函数
    callback: options.callback || function () {},

    // 图片大小
    size: file.size,
    // 图片宽度
    width: 0,
    // 图片高度
    height: 0,
    // 图片转64位编码
    base64: ''
  };

  // 文件读取
  if (options.reader) {
    options.reader.onloadend = function (e) {
      // 读取文件内容
      options.base64 = e.target.result;
      options.size = options.base64.length;

      let isok = false;

      // 如果图片大小大于限制，就压缩
      if (options.maxsize > 0 && options.size > options.maxsize) {
        isok = true;
      } else {
        // 恢复初始值
        options.scale = options.max = 1;
      }

      // 有水印
      if (options.marktext != null) {
        isok = true;
      }

      // 需要处理
      if (isok) {
        // eslint-disable-next-line no-undef
        let img = new Image();
        img.src = options.base64;
        // 读取图片
        img.onload = function () {
          // 创建画板
          let canvas = document.createElement('canvas');

          // 按比例缩小图片naturalWidth
          options.width = img.naturalWidth * options.max;
          options.height = img.naturalHeight * options.max;

          canvas.width = options.width;
          canvas.height = options.height;

          let context = canvas.getContext('2d');
          context.drawImage(img, 0, 0, options.width, options.height);

          // 水印判断
          if (options.marktext != null) {
            // 创建水印画板
            let markCanvas = document.createElement('canvas');

            markCanvas.width = options.width;
            markCanvas.height = options.height;

            let watermarkContext = markCanvas.getContext('2d');
            watermarkContext.font = options.markfont;
            watermarkContext.lineWidth = '1';
            watermarkContext.fillStyle = options.markstyle;
            watermarkContext.textBaseline = 'middle';
            watermarkContext.fillText(
              options.marktext,
              options.markx,
              options.marky
            );
            context.drawImage(markCanvas, 0, 0, options.width, options.height);
          }

          // 转换数据
          options.base64 = canvas.toDataURL(options.type, options.scale);
          // 处理后的图片大小
          options.size = options.base64.length;
          // 返回
          options.callback(options);
        };
      } else {
        // 返回
        options.callback(options);
      }
    };
    options.reader.readAsDataURL(file);
  }
};

export { md5, ubbEncode, ubbDecode, imgMin };

export * from './base64';
